import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { RoleService } from 'services/role.service';
import { RouterDataResolver } from 'services/router.resolver';
import { LinesOfAuthorityService } from '../../../api-services/lines-of-authority.service';
import { SharedService } from '../../../services';
import { ShepheredTourConst, tenantType, tenantTypeCap, RolePermissionType, PermissionAccessType } from 'shared/constant'
import { TaskService } from '../../../api-services/task.service';
import { ShepherdTourService } from 'services/shepherd-tour.service';
import { MalihuScrollbarService } from 'ngx-malihu-scrollbar';
import { PackageService } from 'api-services/package.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements AfterViewInit,OnInit {
  @ViewChild('sideBar') sideBarEle: ElementRef<HTMLElement>;
  @ViewChild('currentTour') currentTour: ElementRef<HTMLElement>;
  @Output() sideNvValue = new EventEmitter<any>();
 manageCarriersUrl = "manage/carriers"
  isAdmin?: boolean = false;
  isOpenDropdown: boolean = false;
  darkScrollbarOptions: MCustomScrollbar.CustomScrollbarOptions = { axis: 'y', theme: 'light', setHeight: 'calc(100vh - 92px)', mouseWheel: {scrollAmount: 200}, keyboard: {scrollAmount: 'auto'} };

  hideSideNav: boolean = JSON.parse(sessionStorage.getItem('collapseValue')) ? JSON.parse(sessionStorage.getItem('collapseValue')) : false;
  isContactUser = false;
  isMGAUser = false;
  isGuestUser = false;
  isOnboardingUser = false;
  isBranchOnboardingUser = false;
   BranchHireDate :any=null;
  isCarrierUser = false;
  isAgencyUser = false;
  isAdminUser = false;
  isAccountOwner = false;
  hideSideBar = false;
  tenantTypeId = localStorage['tenantTypeId'];
  tenantType = tenantType;
  tenantTypeCap = tenantTypeCap;
  activeAlertsCount = localStorage.getItem("ActiveTaskCount");
  activeAlertsCountOld = localStorage.getItem("ActiveTaskCountOld");
  downliningTypeId = Number(localStorage.getItem("downliningTypeId"));
  downliningUrl = "downlining";
  npnTypeId: number = Number(localStorage["npnTypeId"]);
  isDownliningPermitted: boolean = false;
  isIndividualUser = false;
  mobileView: boolean = window.innerWidth <= 767.97;
  accountingTransactionEnabled = false;
  isPackagesEnabled: boolean = localStorage.getItem('isPackagesEnabled') === 'true';
  private taskUpdateSubscription: Subscription;
  newContractingRequestCount: number = JSON.parse(localStorage.getItem("newContractingRequestCount") || "0");

  constructor(private roleService: RoleService, private shepheredToureService: ShepherdTourService,
    private routerDataResolver: RouterDataResolver, private LinesOfAuthorityService: LinesOfAuthorityService
    , private sharedService: SharedService
    , private taskService: TaskService,
    private mScrollbarService: MalihuScrollbarService,
    private packageService: PackageService
  ) {
    this.hideSideBar = routerDataResolver.hideSideBar;

  }

  ngOnInit(): void {
    this.isContactUser = this.roleService.isContactUser;
    this.isMGAUser = this.roleService.isMGAUser;
    this.isGuestUser = this.roleService.isGuestUser;
    this.isOnboardingUser = this.roleService.isOnboardingUser;
    this.isBranchOnboardingUser = this.roleService.isBranchOnboardingUser;
    this.BranchHireDate = this.roleService.BranchHireDate;
    this.isCarrierUser = this.roleService.isCarrierUser;
    this.isAgencyUser = this.roleService.isAgencyUser;
    this.isAdminUser = this.roleService.isAdminUser;
    this.isAccountOwner = this.roleService.isTenantOwnerUser;
    this.isDownliningPermitted = this.roleService.isFeatureAccessible(RolePermissionType.Downlining, PermissionAccessType.Yes);
    this.isIndividualUser = this.roleService.isIndividualUser;
    this.accountingTransactionEnabled = localStorage.getItem('accountingTransactionEnabled') === 'true';
    this.isPackagesEnabled = localStorage.getItem('isPackagesEnabled') === 'true';

    if (localStorage["userRole"] == "admin") {
      this.isAdmin = true;
    }
    if (this.roleService.isMGAUser) {
      this.manageCarriersUrl = "manage/mga-carriers"
    }

    if (this.downliningTypeId == 2) {
      this.downliningUrl = "downlining/ul"
    }
    this.getUnreadTaskCount();

    if(((this.isAgencyUser && this.isContactUser) || (this.isCarrierUser && !this.isContactUser)) && !this.isGuestUser && !this.isOnboardingUser && this.isPackagesEnabled){
        this.getNewContractingRequestCount();
    }

    if(this.mobileView){
      this.hideSideNav = false;
    }
    
    // if(this.isIndividualUser){
      const savedState = localStorage.getItem('isOpenDropdown');
      if (savedState === 'true') {
        this.isOpenDropdown = true;
      }
    // }

    // this.getOldTaskCount();
    
    // shepherd-tour use only
    // if(this.isAdminUser || this.isAccountOwner){
    //   document.body.classList.add('shepherd-css');
    // }
    // var allowUser = this.isAdminUser || this.isAccountOwner ? true : false;
    // setTimeout(() => this.shepheredToureService.setupTour(false, allowUser, ShepheredTourConst.EandOAdmin), 0);
    //end//
  }

  // getOldTaskCount(){
  //   this.LinesOfAuthorityService.getActiveTaskCount(Number(localStorage.getItem('tenantId'))).subscribe(
  //     (response: any) => {
  //       this.activeAlertsCountOld = response;
  //       localStorage.setItem("ActiveTaskCountOld", this.activeAlertsCount?.toString());
  //     },
  //     (error: any) => {
  //       console.log(error);
  //     }
  //   );

  //   this.taskUpdateSubscription = this.sharedService.getUpdate().subscribe
  //    (res => {
  //      if (res != null && res) {

  //        this.LinesOfAuthorityService.getActiveTaskCount(Number(localStorage.getItem('tenantId'))).subscribe(
  //          (response: any) => {
  //            this.activeAlertsCountOld = response;
  //            localStorage.setItem("ActiveTaskCountOld", this.activeAlertsCountOld?.toString());
  //          },
  //          (error: any) => {
  //            console.log(error);
  //          }
  //        );
  //      }
  //    });
  // }

  

  ngAfterViewInit() {
    this.taskUpdateSubscription = this.sharedService.unreadTaskCountReloadObs.subscribe(() => {
      this.getUnreadTaskCount();
    });

    this.taskUpdateSubscription = this.sharedService.updateContractingNewStatusCountObs.subscribe(() => {
      this.getNewContractingRequestCount();
    });

    // this.getSidebarElementHeight();

    this.mScrollbarService.initScrollbar('#side-bar-menu', { axis: 'y', theme: 'light' });
  }

  ngOnDestroy() {
    this.taskUpdateSubscription.unsubscribe();
    this.mScrollbarService.destroy('#side-bar-menu');
  }

  getUnreadTaskCount() {
    this.taskService.getUnreadTaskCount().subscribe(
      (response: any) => {
        this.activeAlertsCount = response;
        localStorage.setItem("ActiveTaskCount", this.activeAlertsCount?.toString());
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getNewContractingRequestCount(){
    this.packageService.getNewContractingRequestCount(this.isCarrierUser).subscribe(
       (response: any) => {
        this.newContractingRequestCount = response;
        localStorage.setItem("newContractingRequestCount", this.newContractingRequestCount?.toString());
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  toggleSideNav() {
    this.hideSideNav = !this.hideSideNav;
    this.sideNvValue.emit(this.hideSideNav);
    sessionStorage.setItem('collapseValue', JSON.stringify(this.hideSideNav));
  }

  onResize(event) {
    if (event.target.innerWidth <= 1366 && this.hideSideNav == false) {
      this.toggleSideNav();
    }
    else if (event.target.innerWidth > 1366 && this.hideSideNav == true) {
      this.toggleSideNav();
    }
  }
  
  // getSidebarElementHeight() {
  //   const currentTour = this.currentTour.nativeElement.offsetTop;    
  //   const tourEle = document.querySelector(".extra-tour-div") as HTMLElement;
    
  //   tourEle.style.top = currentTour + "px";
  // }

  toggleMenu(event: Event){
    // if(this.isIndividualUser){
      event.stopPropagation();
      this.isOpenDropdown = !this.isOpenDropdown

      localStorage.setItem('isOpenDropdown', this.isOpenDropdown.toString());

      const targetElement = event.target as Element;
      if (targetElement) {
        const closestEleemnt = targetElement.closest('.dropdown');
      }
    // }
  }
}
